module.exports = __webpack_public_path__ + "dz.1c5b4330f38fcd73efb0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/dz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/dz.svg
// module chunks = styles